<app-loader></app-loader>
<!-- <div class="flex justify-end items-center mt-4 -ml-4 header">
  <button class="flex" style="background: var(--gradient)" (click)="showGuide()" class="Ad">
    User Manual
  </button>
</div> -->
<!-- <div class="header px-4 py-2 gap-3"> -->
<!-- Heading -->
<!-- <h1 class="text-2xl font-bold text-white text-center md:text-left">
    Choose Your Lucky Draw!
  </h1> -->

<!-- Buttons -->
<!-- <div class="hidden sm:flex justify-end gap-3 mt-3 md:mt-0"> -->
<button
  class="relative flex items-center gap-2 px-4 py-2 rounded-lg bg-white/10 backdrop-blur-md border border-cyan-400 text-cyan-300 font-semibold text-sm shadow-[0_0_10px_rgba(34,211,238,0.5)] hover:shadow-[0_0_15px_rgba(34,211,238,0.8)] hover:scale-105 transition-all duration-300 overflow-hidden ml-auto"
  (click)="showGuide()">
  <span class="absolute inset-0 bg-gradient-to-r from-cyan-400 to-teal-400 opacity-15 blur-lg animate-pulse"></span>

  <span class="relative z-10 tracking-wide">Playbook</span>
</button>

<!-- <button class="floating-icon px-4 py-2 sm:px-6 sm:py-3 --button" (click)="RedirectToClaim()">
      <img src="/Images/sidebar-icons/radeem.png" alt="play" class="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
      <span class="text-sm sm:text-base">Claim Reward</span>
    </button>
  </div>
</div> -->
<!-- <div class="header flex px-4 py-2 gap-3 claim-button">
  <button
    class=" floating-icon px-4 py-2 sm:px-6 sm:py-3 --button ml-auto"
    (click)="RedirectToClaim()">
    <img src="/Images/sidebar-icons/radeem.png" class="w-5 h-5 sm:w-6 sm:h-6 mr-2" />
    <span class="text-sm sm:text-base">Claim Reward</span>
  </button>
</div> -->

<!-- Filter or Search with Header / -->

<div class="mb-8 lg:mt-[50px] px-6 flex flex-col">
  <div class="flex flex-col-reverse lg:flex-row justify-between items-start lg:items-center gap-2 w-full">
    <!-- Tabs Section -->
    <div class="flex items-center justify-center mt-4 lg:mt-0">
      <div class="inline-flex rounded-lg border border-[#2ee4e8] overflow-hidden text-[12px] ml-[-28px] sm:ml-[0]">

        <!-- Today Tab (gradient active) -->
        <button (click)="changeTab('Today')" class="px-6 py-2 font-semibold rounded-md focus:outline-none transition"
          [ngStyle]="selectedTab === 'Today'
                      ? {'background': 'linear-gradient(to bottom right, #9efcff 10%, #164d61 30%)', 'color': 'white'}
                      : {'color': '#2ee4e8'}">
          All
        </button>

        <!-- Claim Reward Tab -->
        <button (click)="changeTab('claim')" class="block px-6 py-2 font-semibold focus:outline-none transition"
          [ngStyle]="selectedTab === 'claim'
                      ? {'background': 'linear-gradient(to bottom right, #9efcff 10%, #164d61 30%)', 'color': 'white'}
                      : {'color': '#2ee4e8'}">
          Claim Reward
        </button>

        <!-- My Lotteries Tab -->
        <button (click)="changeTab('myLottery')"
          class="px-6 py-2 font-semibold focus:outline-none border-l border-cyan-400 transition" [ngStyle]="selectedTab === 'myLottery'
                      ? {'background': 'linear-gradient(to bottom right, #9efcff 10%, #164d61 30%)', 'color': 'white'}
                      : {'color': '#2ee4e8'}">
          My Lotteries
        </button>

        <!-- Winners Tab -->
        <button (click)="changeTab('winners')"
          class="px-6 py-2 font-semibold focus:outline-none border-l border-cyan-400 transition" [ngStyle]="selectedTab === 'winners'
                      ? {'background': 'linear-gradient(to bottom right, #9efcff 10%, #164d61 30%)', 'color': 'white'}
                      : {'color': '#2ee4e8'}">
          Winners
        </button>

      </div>
    </div>

    <!-- Search Section -->
    <div class="flex sm:flex-row items-center gap-2 w-full lg:w-[30rem] mt-4 lg:mt-0">
      <div class="relative flex-1">
        <input type="text" placeholder="Search..." [(ngModel)]="searchTerm" (keyup.enter)="onSearch()"
          class="w-full bg-transparent text-white border border-[#2ee4e8] text-sm rounded-tl-lg rounded-bl-lg rounded-tr-none rounded-br-none py-2 px-4 pl-10 focus:outline-none focus:ring-2 focus:ring-cyan-400" />
        <svg class="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" fill="none"
          stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
      </div>
      <button (click)="onSearch()"
        class="text-black px-4 py-2 rounded-tr-lg rounded-br-lg rounded-tl-none rounded-bl-none font-semibold --button">
        Search
      </button>
    </div>
  </div>
</div>

<div class="rounded-xl p-4 md:block hidden -mt-[5rem] header-box">
  <!-- Header box -->
  <div class="flex justify-center -mb-[14px]">
    <div class="relative inline-block">
      <!-- Background Image -->
      <img src="Edge.png" alt="History Background" class="w-full max-w-md mx-auto h-auto rounded-t-xl" />

      <!-- Text Overlay -->
      <div class="absolute inset-0 flex items-center justify-center text-white font-bold text-lg">
        Lotteries
      </div>
    </div>
  </div>

  <div class="flex flex-col w-full mt-2">
    <!-- Table header -->
    <div class="grid text-gray-400 text-sm mb-2 bg-[#13192e] px-1 py-1.5 rounded-md border-b-2 border-[#a6b1c2]">
      <!-- content -->
    </div>
  </div>
</div>

<!-- Filter or Search with Header Ends  -->

<div *ngIf="!showWinnersModal" class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 px-6 gap-y-4 gap-x-3">
  <ng-container *ngIf="lotteryList.length > 0; else noDataResponsive">
    <div *ngFor="let card of lotteryList; trackBy: trackByFn"
      class="group mt-2 relative w-auto h-auto  md:min-h-[400px] cursor-pointer rounded-[25px] overflow-hidden">

      <!-- 1. Background Overlay -->
      <div class="absolute inset-0 bg-[#0f1423]/95 backdrop-blur-2xl z-0"></div>

      <!-- 2. ORIGINAL DYNAMIC BORDER (Wahi Logic) -->
      <div class="absolute inset-0 rounded-[25px] border-[2px] z-10 pointer-events-none" [ngStyle]="{
         'background':
           'linear-gradient(rgba(15,20,35,1), rgba(15,20,35,1)) padding-box, ' +
           'linear-gradient(to right, transparent, ' + color + ' 50%, transparent) border-box, ' +
           'linear-gradient(to bottom, ' + color + '40, ' + color + '10 50%, ' + color + '40) border-box'
       }" style="border-color: transparent;">
      </div>

      <!-- 3. Inner Content -->
      <div class="relative z-20 h-full w-full p-2 sm:p-4 flex flex-col items-center"
        [ngStyle]="{'background': 'linear-gradient(to bottom, ' + color + '08, ' + color + '15, ' + color + '08)'}">

        <!-- Winning Amount -->
        <div class="text-center mt-2">
          <p class="text-[14px] sm:text-[16px] uppercase text-white font-bold tracking-widest mt-1">
            Jackpot Prize
          </p>

          <div
            class="my-1 inline-block px-3 py-[2px] rounded-full bg-gradient-to-r from-yellow-500/20 via-yellow-300/30 to-yellow-500/20 border border-yellow-400/40 backdrop-blur-sm">
            <span class="text-[18px] sm:text-[22px] font-bold tracking-widest text-yellow-300">
              UPTO
            </span>
          </div>

          <h2 class="text-[32px] sm:text-[60px] font-black tracking-tight leading-none text-transparent bg-clip-text
     bg-gradient-to-b from-yellow-400 via-yellow-300 to-yellow-600
     drop-shadow-[2px_2px_2px_rgba(0,0,0,0.4)]">
            ${{ card.WinnersAmount }}
          </h2>
        </div>

        <!-- Lottery Name (Simplified for better readability than SVG) -->
        <div class="w-full text-center mt-4" *ngIf="card.Status === 'Open'">
          <span class=" text-sm sm:text-lg font-extrabold uppercase tracking-[0.2em] text-white
          group-hover:text-cyan-200 transition-colors">
            Hurry Up
          </span>
        </div>

        <div class="w-full text-center mt-4" *ngIf="card.Status === 'Close'">
          <span class=" text-[8px] sm:text-lg font-extrabold uppercase tracking-[0.2em] text-white
          group-hover:text-cyan-200 transition-colors">
            YOUR REWARD IS READY!
          </span>
        </div>

        <!-- Timer Section -->
        <div class="w-full">
          <div *ngIf="card.Status === 'Open'"
            class="mx-auto w-[90%] p-[1px] rounded-lg bg-gradient-to-r from-white/10 to-white/5">
            <div class="flex items-center justify-center gap-1 sm:gap-2 bg-black/40 rounded-lg py-1 shadow-inner">
              <span class="font-mono text-lg sm:text-2xl text-cyan-200">{{ card.time.hh }}</span>
              <span class="text-white/30 text-[16px] sm:text-2xl">:</span>
              <span class="font-mono text-lg sm:text-2xl text-cyan-200">{{ card.time.mm }}</span>
              <span class="text-white/30 text-[16px] sm:text-2xl">:</span>
              <span class="font-mono text-lg sm:text-2xl text-cyan-200">{{ card.time.ss }}</span>
            </div>
          </div>

          <!-- Sparkle Dots -->
          <div class="absolute inset-0 pointer-events-none">
            <span class="absolute w-1 h-1 bg-red-400 rounded-full top-10 left-5"></span>
            <span class="absolute w-1.5 h-1.5 bg-green-400 rounded-full top-16 left-20"></span>
            <span class="absolute w-1 h-1 bg-blue-400 rounded-full top-5 right-10"></span>
            <span class="absolute w-2 h-2 bg-yellow-400 rounded-full top-20 right-5"></span>
            <span class="absolute w-1 h-1 bg-purple-400 rounded-full top-3 left-32"></span>

            <!-- Additional dots -->
            <span class="absolute w-1.5 h-1.5 bg-pink-400 rounded-full top-12 left-28"></span>
            <span class="absolute w-1 h-1 bg-indigo-400 rounded-full top-8 right-20"></span>
            <span class="absolute w-2 h-2 bg-teal-400 rounded-full top-18 left-40"></span>
            <span class="absolute w-1 h-1 bg-orange-400 rounded-full top-6 right-32"></span>
            <span class="absolute w-1.5 h-1.5 bg-cyan-400 rounded-full top-22 left-10"></span>
            <span class="absolute w-1 h-1 bg-lime-400 rounded-full top-4 right-5"></span>
          </div>
        </div>

        <div class="relative text-center py-4">
          <!-- Text -->
          <h2
            class="text-2xl sm:text-3xl font-bold bg-gradient-to-r from-yellow-400 via-orange-400 to-yellow-500 bg-clip-text text-transparent drop-shadow-[0_2px_4px_rgba(0,0,0,0.5)]">
            {{ card.LotteryName | uppercase }}
          </h2>
          <p *ngIf="card.Status === 'Open'"
            class="text-lg sm:text-md font-semibold text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
            Buy to Claim Your Prize!
          </p>

          <p *ngIf="card.Status === 'Close'"
            class="text-lg sm:text-md font-semibold text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.5)]">
            Tap to Claim Your Prize!
          </p>


        </div>

        <div class="flex justify-center items-center w-full mb-2 px-1">
          <span
            class="bg-white/10 backdrop-blur-md  px-3 py-1 rounded-full text-[#F2C749] font-bold text-[14px] sm:text-[13px]">
            Only For ${{ card.TicketPrice }}
          </span>
        </div>
        <!-- CTA Button -->
        <button *ngIf="card.Status === 'Open' && card.IsDisabled === false" (click)="BuyTicket(card)" class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full
         bg-white/3 border border-white/10 backdrop-blur-md
         text-white font-medium text-[16px] transition-all
         hover:bg-white/10 hover:border-white/40
         shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">

          <span
            class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

          <span class="relative flex items-center gap-1.5">
            <span class="font-bold">Buy Now</span>
          </span>
        </button>


        <!-- BUYING TIME OVER -->
        <button *ngIf="card.Status === 'Open' && card.IsDisabled" disabled class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full
         bg-white/3 border border-white/10 backdrop-blur-md
         text-white font-medium text-[16px] opacity-70 cursor-not-allowed
         shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">

          <span
            class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

          <span class="relative flex items-center gap-1.5">
            <span class="font-bold">Buying time over</span>
          </span>
        </button>


        <!-- SEE DETAILS -->
        <button *ngIf="card.Status === 'Close'" (click)="AnnounceTicket(card)" class="relative w-full flex items-center justify-center gap-1.5 py-3 rounded-full
            bg-white/3 border border-white/10 backdrop-blur-md
            text-white font-medium text-[16px] transition-all
            hover:bg-white/10 hover:border-white/40
            shadow-[inset_0_0_8px_rgba(255,255,255,0.1),0_3px_8px_rgba(0,0,0,0.4)]">

          <span
            class="absolute inset-0 rounded-full bg-gradient-to-b from-white/20 to-transparent pointer-events-none"></span>

          <span class="relative flex items-center gap-1.5">
            <span class="font-bold">See Details</span>
          </span>
        </button>
      </div>
    </div>
  </ng-container>

  <style>
    @keyframes shimmer {
      100% {
        transform: translateX(100%);
      }
    }
  </style>

</div>
<ng-template #noDataResponsive>
  <!-- Small screens -->
  <div class="block lg:hidden">
    <ng-container *ngTemplateOutlet="noDataSm"></ng-container>
  </div>

  <!-- Large screens -->
  <div class="hidden lg:block">
    <ng-container *ngTemplateOutlet="noDataLg"></ng-container>
  </div>
</ng-template>

<!-- Large screens template -->
<ng-template #noDataLg>
  <div class="absolute inset-0 flex flex-col items-center justify-center text-center text-gray-400 pointer-events-none">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mb-4 pointer-events-auto" fill="none" viewBox="0 0 24 24"
      stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p class="text-2xl font-semibold mb-2 pointer-events-auto">No Data Found</p>
  </div>
</ng-template>

<!-- Small screens template -->
<ng-template #noDataSm>
  <div
    class="absolute left-0 right-0 flex flex-col items-center justify-center text-center text-gray-400 pointer-events-none sm:top-[300px] lg:top-0">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-16 w-16 mb-4 pointer-events-auto" fill="none" viewBox="0 0 24 24"
      stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round"
        d="M9.75 9.75L14.25 14.25M14.25 9.75L9.75 14.25M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
    </svg>
    <p class="text-2xl font-semibold mb-2 pointer-events-auto">No Data Found</p>
  </div>
</ng-template>

<ng-container *ngIf="showWinnersModal">
  <div
    class="fixed modal-overlay z-999 inset-0 z-50 flex items-start sm:items-center justify-center p-2 sm:p-4 bg-slate-950/90 backdrop-blur-sm overflow-y-auto">
    <div
      class="relative modal slide-up z-999 w-[95vw] max-w-xs sm:max-w-sm md:max-w-2xl lg:max-w-5xl max-h-[95vh] sm:max-h-[90vh] md:max-h-[85vh] overflow-y-auto rounded-xl sm:rounded-2xl md:rounded-[28px] border border-cyan-400/20 bg-slate-900/95 shadow-2xl ring-1 ring-cyan-400/10">
      <div
        class="absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-transparent to-emerald-400/10 pointer-events-none">
      </div>

      <div class="relative z-10 p-3 pb-[80px] sm:pb-0 md:p-5 lg:p-6"> <!-- Mobile Header - Stack vertically -->
        <div class="flex flex-col gap-2 sm:gap-3 md:flex-row md:items-center md:justify-between md:gap-4">
          <div class="flex items-center gap-2 sm:gap-3 md:gap-4">
            <div
              class="grid h-8 w-8 sm:h-10 sm:w-10 md:h-14 md:w-14 place-items-center rounded-xl sm:rounded-2xl md:rounded-3xl bg-gradient-to-br from-cyan-400 to-sky-600 text-white shadow-lg shadow-cyan-500/20">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 sm:h-6 sm:w-6 md:h-8 md:w-8" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M8 21h8" />
                <path d="M12 17v4" />
                <path d="M6 7h12" />
                <path d="M9 7v10" />
                <path d="M15 7v10" />
                <path d="M5 7a7 7 0 0 1 14 0v2h-2v4h-8V9H5V7Z" />
              </svg>
            </div>
            <div class="min-w-0 flex-1">
              <p class="text-xs uppercase tracking-[0.32em] text-cyan-300/80">Lottery Winners</p>
              <h2 class="text-base sm:text-lg md:text-2xl lg:text-3xl font-semibold text-white truncate">Latest Draw
                Winners</h2>
            </div>
          </div>

          <button (click)="closeWinnersModal()"
            class="self-end sm:self-auto inline-flex h-8 w-8 sm:h-10 sm:w-10 md:h-12 md:w-12 items-center justify-center rounded-lg sm:rounded-xl md:rounded-full border border-white/10 bg-white/5 text-cyan-200 transition hover:bg-cyan-400/15 hover:text-white">
            <span class="sr-only">Close winners modal</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 sm:h-4 sm:w-4 md:h-5 md:w-5" viewBox="0 0 24 24"
              fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <path d="M6 18L18 6" />
              <path d="M6 6l12 12" />
            </svg>
          </button>
        </div>

        <!-- Stats Cards - Stack on mobile -->
        <div class="mt-3 sm:mt-4 md:mt-5 grid gap-2 sm:gap-3 md:gap-4 grid-cols-1 sm:grid-cols-2">
          <div
            class="rounded-lg sm:rounded-xl md:rounded-[24px] border border-white/10 bg-slate-950/80 p-2 sm:p-3 md:p-4 shadow-sm">
            <p class="text-xs uppercase tracking-[0.25em] text-slate-400">Winners announced</p>
            <p class="mt-1 sm:mt-2 md:mt-3 text-xl sm:text-2xl md:text-4xl font-semibold text-white">{{ announcedTickets.length || 3 }}</p>
            <p class="mt-1 text-xs sm:text-xs md:text-sm text-slate-300">Top winning tickets from this draw.</p>
          </div>
          <!-- Hide Fast cash claim on mobile, show on larger screens -->
          <div
            class="hidden sm:block rounded-lg sm:rounded-xl md:rounded-[24px] border border-white/10 bg-slate-950/80 p-2 sm:p-3 md:p-4 shadow-sm">
            <p class="text-xs uppercase tracking-[0.25em] text-slate-400">Latest update</p>
            <p class="mt-1 sm:mt-2 md:mt-3 text-base sm:text-lg md:text-4xl font-semibold text-white leading-tight">Fast
              cash claim</p>
            <p class="mt-1 text-xs sm:text-xs md:text-sm text-slate-300">Tap any winner to check more details.</p>
          </div>
        </div>

        <div class="mt-3 sm:mt-4 md:mt-6">
          <!-- Loading State - Responsive grid -->
          <div *ngIf="announcedTickets.length === 0"
            class="grid gap-2 sm:gap-3 md:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
<ng-container *ngIf="isLoadingt">
    <div *ngFor="let i of [1, 2, 3]"
      class="animate-pulse rounded-lg sm:rounded-xl md:rounded-[24px] border border-white/10 bg-slate-950/80 p-3 sm:p-4 md:p-6 text-center shadow-[0_20px_60px_-40px_rgba(14,165,233,0.65)]">
      <div class="mx-auto mb-2 sm:mb-3 md:mb-4 flex h-10 w-10 sm:h-12 sm:w-12 md:h-16 md:w-16 items-center justify-center rounded-full bg-slate-800 text-slate-500">
        <span class="text-xs sm:text-sm md:text-xl">...</span>
      </div>
      <p class="text-xs sm:text-xs md:text-sm font-semibold text-slate-400">Loading winners</p>
    </div>
  </ng-container>

  <ng-container *ngIf="!isLoadingt">
    <div *ngFor="let ticketNum of displayTickets"
      class="rounded-lg sm:rounded-xl md:rounded-[24px] border border-white/10 bg-slate-950/80 p-3 sm:p-4 md:p-6 text-center shadow-[0_20px_60px_-40px_rgba(14,165,233,0.65)]">
      <div class="mx-auto mb-2 sm:mb-3 md:mb-4 flex h-10 w-10 sm:h-12 sm:w-12 md:h-16 md:w-16 items-center justify-center rounded-full bg-cyan-500/10 text-cyan-300">
        <span class="text-xs sm:text-sm md:text-xl font-semibold">#{{ ticketNum }}</span>
      </div>
      <p class="text-xs sm:text-xs md:text-sm font-semibold text-slate-200">Winner</p>
    </div>
  </ng-container>
          </div>

          <!-- Winners Display -->
          <div *ngIf="announcedTickets.length > 0" class="space-y-3 sm:space-y-4 md:space-y-5">
            <!-- Top 3 Winners - Stack on mobile -->
            <div class="grid gap-2 sm:gap-3 md:gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
              <div *ngFor="let winner of announcedTickets.slice(0, 3); let i = index"
                class="rounded-lg sm:rounded-xl md:rounded-[24px] border border-white/10 bg-slate-950/85 p-2 sm:p-3 md:p-5 shadow-lg">
                <div class="flex items-center justify-between gap-2 sm:gap-2 md:gap-3">
                  <div class="min-w-0 flex-1">
                    <p class="text-xs uppercase tracking-[0.32em] text-cyan-300/80">Rank</p>
                    <p class="mt-1 text-base sm:text-lg md:text-2xl font-semibold text-white">{{ i + 1 }}<sup
                        *ngIf="i < 3">{{ i === 0 ? 'st' : i === 1 ? 'nd' : 'rd' }}</sup><span *ngIf="i >= 3">th</span>
                    </p>
                  </div>
                  <div
                    class="rounded-xl sm:rounded-2xl md:rounded-3xl bg-cyan-500/10 px-2 py-1 text-xs font-semibold uppercase text-cyan-200 whitespace-nowrap">
                    Top player</div>
                </div>
                <div class="mt-2 sm:mt-3 md:mt-5 space-y-2 sm:space-y-2 md:space-y-3">
                  <div class="rounded-xl sm:rounded-2xl md:rounded-3xl bg-white/5 p-2 sm:p-3 md:p-4">
                    <p class="text-xs uppercase tracking-[0.25em] text-slate-400">Ticket</p>
                    <p class="mt-1 text-xs sm:text-sm md:text-lg font-semibold text-white truncate">#{{
                      winner.TicketNumber }}</p>
                  </div>
                  <div
                    class="flex items-center justify-between gap-2 rounded-xl sm:rounded-2xl md:rounded-3xl bg-cyan-500/5 p-2 sm:p-3 md:p-4">
                    <div class="min-w-0 flex-1">
                      <p class="text-xs text-slate-400">Players</p>
                      <p class="mt-1 text-xs sm:text-xs md:text-sm font-semibold text-white">{{ winner.CustomerCount }}
                      </p>
                    </div>
                    <div class="rounded-full bg-white/10 px-2 py-1 text-xs text-cyan-100 whitespace-nowrap">Winner</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Additional Winners Table - Mobile friendly -->
            <div *ngIf="announcedTickets.length > 3"
              class="overflow-hidden rounded-lg sm:rounded-xl md:rounded-[24px] border border-white/10 bg-slate-950/80">
              <div
                class="grid grid-cols-3 gap-1 sm:gap-2 md:gap-4 bg-slate-900/90 px-2 py-2 sm:px-3 sm:py-3 md:px-5 md:py-4 text-xs uppercase tracking-[0.28em] text-slate-400">
                <span class="text-center">Rank</span>
                <span class="text-center">Ticket</span>
                <span class="text-center">Players</span>
              </div>
              <div class="divide-y divide-white/5 max-h-40 sm:max-h-48 md:max-h-60 overflow-y-auto">
                <div *ngFor="let winner of announcedTickets.slice(3); let idx = index"
                  class="grid grid-cols-3 gap-1 sm:gap-2 md:gap-4 px-2 py-2 sm:px-3 sm:py-3 md:px-5 md:py-4 text-xs text-slate-200">
                  <span class="font-semibold text-cyan-200 text-center">{{ idx + 4 }}<span
                      *ngIf="idx + 4 === 1">st</span><span *ngIf="idx + 4 === 2">nd</span><span
                      *ngIf="idx + 4 === 3">rd</span><span *ngIf="idx + 4 > 3">th</span></span>
                  <span class="font-mono truncate text-center">#{{ winner.TicketNumber }}</span>
                  <span
                    class="inline-flex items-center justify-center rounded-full bg-white/5 px-1 py-1 sm:px-2 sm:py-1 md:px-3 md:py-1 text-xs text-slate-200">{{
                    winner.CustomerCount }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>